export default function select() {

    const selects = document.querySelectorAll(".select");

    document.addEventListener("click", function () {
        document.querySelector(".select__list_open")?.classList.remove("select__list_open");
    });

    for (let select of selects) {
        let options = select.querySelectorAll(".select__option");
        let value = select.querySelector(".select__value");
        let list = select.querySelector(".select__list");
        let check = select.querySelector(".select__check");

        if (!value || !list) continue;

        if (check) {
            check.setCustomValidity(check.dataset.error || 'Выберите из списка');
            check.addEventListener('click', (e) => e.preventDefault());
        }

        value.addEventListener("click", function (e) {
            e.stopPropagation();

            if (!list.classList.contains("select__list_open")) {
                document.querySelector(".select__list_open")?.classList.remove("select__list_open");
                list.classList.add("select__list_open");
            } else {
                list.classList.remove("select__list_open");
            }
        });

        for (let option of options) {
            option.addEventListener("click", function (e) {
                e.stopPropagation();
                value.value = option.innerHTML;
                value.dataset.value = option.dataset.value;
                list.classList.remove("select__list_open");

                if (check) {
                    check.checked = true;
                    check.setCustomValidity('');
                }

                value.dispatchEvent(new Event('change', { bubbles: true }));
            });
        }

        value.closest('form')?.addEventListener('reset', () => {
            requestAnimationFrame(() => {
                value.dataset.value = '';
                if (check) {
                    check.checked = false;
                    check.setCustomValidity(check.dataset.error || 'Выберите из списка');
                }
            });
        });
    }

}
